import { render, staticRenderFns } from "./filtersProjectsComponent.vue?vue&type=template&id=6030f546&"
import script from "./filtersProjectsComponent.vue?vue&type=script&lang=js&"
export * from "./filtersProjectsComponent.vue?vue&type=script&lang=js&"
import style0 from "./filtersProjectsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports